import React, { useEffect, useState, useCallback } from 'react'
import { getNetworkStatus } from '../generic/crud'

const NetworkStatusIndicator = ({ onConfigureClick }) => {
    const [networkStatus, setNetworkStatus] = useState(null)
    const [loading, setLoading] = useState(true)
    const [errored, setErrored] = useState(false)

    const fetchStatus = useCallback(() => {
        getNetworkStatus()
            .then(({ data }) => {
                setNetworkStatus(data)
                setErrored(false)
                setLoading(false)
            })
            .catch(() => {
                setErrored(true)
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        fetchStatus()
        const interval = setInterval(fetchStatus, 5000)
        return () => clearInterval(interval)
    }, [fetchStatus])

    const eth = networkStatus?.ethernet
    const wifi = networkStatus?.wifi
    const ethConnected = !!eth?.connected
    const wifiConnected = !!wifi?.connected
    const anyConnected = ethConnected || wifiConnected

    let color = 'info'
    let iconClass = 'bi bi-question-circle'
    let title = 'Checking network status...'
    let detail = ''
    let isDown = false

    if (errored) {
        color = 'info'
        iconClass = 'bi bi-question-circle'
        title = 'Unable to check network status'
        detail = 'Configure the network to continue'
    } else if (loading) {
        color = 'info'
        iconClass = 'bi bi-question-circle'
        title = 'Checking network status...'
        detail = ''
    } else if (ethConnected) {
        color = 'success'
        iconClass = 'bi bi-ethernet'
        title = 'Connected via Ethernet'
        detail = eth.ip ? `IP ${eth.ip}` : ''
    } else if (wifiConnected) {
        color = 'success'
        iconClass = 'bi bi-wifi'
        title = `Connected to ${wifi.ssid || 'WiFi'}`
        detail = wifi.signal != null ? `Signal ${wifi.signal}%` : ''
    } else {
        color = 'danger'
        iconClass = 'bi bi-wifi-off'
        title = 'No network connection'
        detail = 'Set up WiFi to continue'
        isDown = true
    }

    const buttonClass = isDown ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light-primary'

    return (
        <div className={`bg-light-${color} p-4 rounded-3 mb-6`}>
            <div className='d-flex align-items-center'>
                <div className='symbol symbol-30px me-3'>
                    <div className={`symbol-label bg-${color}`}>
                        <i className={`${iconClass} fs-5 text-white`} />
                    </div>
                </div>
                <div className='flex-grow-1'>
                    <div className={`text-${color} fw-bold fs-7`}>{title}</div>
                    {detail && <div className='text-gray-700 fs-8'>{detail}</div>}
                </div>
                <button type='button' className={buttonClass} onClick={onConfigureClick}>
                    Configure Network
                </button>
            </div>
        </div>
    )
}

export { NetworkStatusIndicator }
